import { ComparatorInput } from './ComparatorInput'
import {
  ComparatorType,
  ComparatorVariant,
  useComparatorOperations,
} from './hooks/useComparatorOperations'
import { useFallbackComparator } from './hooks/useFallbackComparator'

type ComparatorOperationInputProps = {
  variant: ComparatorVariant
  selectedOperation: ComparatorType
  setSelectedOperation: (operation: ComparatorType) => void
  numberOfSelectedItems: number
  noNegations?: boolean
  showPartOf?: boolean
}

export const ComparatorOperationInput = ({
  variant,
  selectedOperation,
  setSelectedOperation,
  numberOfSelectedItems,
  noNegations,
  showPartOf,
}: ComparatorOperationInputProps) => {
  const operations = useComparatorOperations(
    variant,
    numberOfSelectedItems,
    noNegations,
    showPartOf,
  )

  useFallbackComparator(operations, selectedOperation, setSelectedOperation)

  return (
    <ComparatorInput<ComparatorType>
      groups={[{ items: operations }]}
      design="light"
      onSelect={setSelectedOperation}
      singleSelect
      value={selectedOperation}
      compact
    >
      {
        operations.find((operation) => operation.value === selectedOperation)
          ?.label
      }
    </ComparatorInput>
  )
}
